import axios from "axios";

export default {
  namespaced: true,
  state() {
    return {
      marquee: {
        isOn: true,
        html:
          '<span class="orange--text font-weight-bold">Important:</span> A scheduled maintenance will occur on 18 May between 12:00 to 14:30 (GMT). We apologize for any incovenience caused.',
      },
    };
  },
  getters: {
    genders(state) {
      return state.genders;
    },
    marquee(state) {
      return state.marquee;
    },
  },
  mutations: {},
  actions: {
    async fetchMarquee(context) {
      await axios
        .get("https://qol-myaccount-default-rtdb.firebaseio.com/marquee.json")
        .then((res) =>
          (() => {
            context.state.marquee = res.data;
          })()
        )
        .catch((error) => alert(error.message));
    },
  },
  modules: {},
};
